import { DatePicker as AntDatePicker } from '@dynamika-shared/ui/DatePicker/DatePicker';
import { ComponentType } from 'react';
import { ControlProps } from '@jsonforms/core';
import { format } from 'date-fns';
import { twMerge } from '@dynamika-shared/utils/twMerge';
import '@dynamika-shared/ui/Input/Input.scss';

export const JsonFormDatePicker: ComponentType<ControlProps> = props => {
  const { handleChange, required, path, schema, uischema } = props;
  return (
    <div className=' flex w-full justify-between border-b border-brightGray py-4 pl-1.5'>
      <p className='min-w-[48%] pr-4 pt-1 text-1424 font-semibold'>
        {props.label}
        <span className='text-redOrange'>{required && ' *'}</span>
      </p>

      <div className='flex flex-col w-full'>
        <AntDatePicker
          placeholder={'Select Date'}
          data-testid={props.label?.split(' ').join('_')}
          onChange={date => {
            if (date) {
              return handleChange(
                path,
                format(date, uischema?.options?.dateFormat)
              );
            } else {
              return handleChange(path, '');
            }
          }}
          picker={schema.format === 'date-month' ? 'month' : 'date'}
          className={twMerge('D7-Input h-[48px] w-full rounded-3xl', props.errors && 'ant-input-error')}
          required={required}
          format={{
            format: schema.format === 'date-month' ? 'MM/YYYY' : 'DD/MM/YYYY',
            type: 'mask',
          }}
          disabledDate={current => {
            let minDate: Date | undefined;

            if (uischema?.options?.minDate) {
              const [month, year] = uischema.options.minDate.split('-');
              minDate = new Date(parseInt(year), parseInt(month) - 1, 1);
            }
            let maxDate: Date | undefined = undefined;

            if (uischema?.options?.maxDate === 'currentDate') {
              maxDate = new Date();
            } else if (uischema?.options?.maxDate) {
              maxDate = new Date(uischema?.options?.maxDate);
            }

            return (
              (minDate && current.toISOString() < minDate.toISOString()) ||
              (maxDate && current.toISOString() > maxDate.toISOString()) ||
              false
            );
          }}
        />
        <span
          className={twMerge(
            'ant-input-error text-1420 font-normal',
            props.errors ? 'visible' : 'invisible'
          )}
        >
          {props.errors}
        </span>
      </div>
    </div>
  );
};
